module.exports=function(scope){ return `<div class="asseco-rds-msg">${scope.msg}</div>
`};